import "../vendor/search.min.js";
import FuiModuleModifier from "./fui-module";

export default class FuiSearchModifier extends FuiModuleModifier {
  override semanticModuleName = "search";
}
